export default __webpack_public_path__ + "static/N0208-967b741fd06a171fb4f9a326d2799be1.png";